/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { UserInterface } from "../../interfaces/Notification.interface";

/**
 * State of the notification slice: the notification currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface NotificationState {
  user: UserInterface;
  levelBreadcrumb: number;
  openDrawerManageSchedules: boolean;
}

const initialState: NotificationState = {
  user: {
    id: "",
    role: {},
    org: {},
    schedule: {
      availability: [],
      exceptions: [],
      timezone: "",
    },
    firstName: "",
    status: "",
    lastName: "",
    middleName: "",
    offlinePsw: "",
    email: "",
    notifications: [],
    contactInfo: {},
    roleId: "",
    organizationId: "",
  },
  levelBreadcrumb: 0,
  openDrawerManageSchedules: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    updateLevelbreadcrumb: (state, action: PayloadAction<number>) => {
      state.levelBreadcrumb = action.payload;
    },
    updateOpenDrawerManageSchedules: (state, action: PayloadAction<boolean>) => {
      state.openDrawerManageSchedules = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateUser, updateLevelbreadcrumb, updateOpenDrawerManageSchedules } =
  notificationSlice.actions;

export default notificationSlice.reducer;
